import {handleActions} from 'redux-actions';

import {SIGN_OUT} from '/redux/action/auth.action';
import {GET_INFO} from '/redux/action/currentUser.action';
import {withPayload} from '/util/reducer.util';

import authSignOut from './currentUser/auth/signOut';
import currentUserGetInfo from './currentUser/getInfo';

const initialState = {
  userId: null,
};

export default handleActions(
  {
    [GET_INFO]: withPayload(currentUserGetInfo),
    [SIGN_OUT]: authSignOut,
  },
  initialState,
);
